<template>
  <div>
    <div class="row">
      <div class="col-md-8">

        <div class="form-group">
          <label for="company-name">Razão Social*</label>
          <input v-model="currentCompany.name" type="text" class="form-control" id="company-name" aria-describedby="emailHelp">
        </div>

        <div class="form-group">
          <label for="company-cnpj">CNPJ*</label>
          <input v-model="currentCompany.cnpj" type="text" class="form-control" id="company-cnpj" v-mask="'XX.XXX.XXX/XXXX-##'">
        </div>

        <div class="form-group">
          <label for="company-ie" v-tooltip.right="{ content: infoIE(), class: 'tooltip-in-modal'}">
            IE <info-icon size="1x"/>
          </label>
          <input v-model="currentCompany.ie" type="text" class="form-control" id="company-ie">
        </div>

        <div class="form-group">
          <label for="company-im">IM</label>
          <input v-model="currentCompany.im" type="text" class="form-control" id="company-im">
        </div>

        <div class="form-group">
          <label>UF*</label>
          <StatesSelect v-model="currentCompany.uf" class="custom-select"/>
        </div>

        <div class="form-group">
          <label for="company-code-city">Cidade*</label>
          <CitySelect
            v-model="currentCompany.cityCode"
            :code-uf="currentCompany.uf"
            id="company-code-city"
            class="custom-select"
          />
        </div>

        <div class="form-group">
          <label for="company-code">Código</label>
          <input v-model="currentCompany.code" id="company-code" type="text" class="form-control">
        </div>

        <div class="form-group">
          <label for="company-phone">Telefone</label>
          <input v-model="currentCompany.phone" id="company-phone" type="text" class="form-control" v-mask="'(##) #### #####'">
        </div>

        <div class="form-group">
          <label for="company-email">Email</label>
          <input v-model="currentCompany.email" id="company-email" type="text" class="form-control">
        </div>
  
        <div v-if="currentCompany.id" class="form-group">
          <button class="btn btn-outline form-control" @click="showModalCityLogin = true">
            Configurar login e senha
          </button>
        </div>
      </div>

      <div class="col-md-4">
        <div v-if="hasCertificate || hasTempCertificate" class="password-certificate px-5">

          <FileIcon size="3x"/>
          <template v-if="hasTempCertificate">
            <p>{{ currentCompany.digitalCertificate.name }}</p>
            <p>{{ formatFileSize(currentCompany.digitalCertificate) }}</p>
          </template>

          <div class="form-group">
            <label for="password-certificate">Senha</label>
            <input v-model="currentCompany.password" autocomplete="new-password"
                   id="password-certificate" type="password" class="form-control">
            <p style="cursor: pointer" v-if="hasCertificate" @click="removeCertificate">Remover certificado</p>
            <p style="cursor: pointer" v-if="hasTempCertificate" @click="currentCompany.digitalCertificate = null">Remover certificado</p>
          </div>

        </div>

        <Upload v-else class="upload"
                is-multiple="false" accept=".pfx, .PFX" :method="setFile">
          <UploadCloudIcon size="2x" class="upload-icon"/>
          <p>Selecione ou arraste o seu arquivo de certificado aqui</p>
        </Upload>
      </div>

    </div>

    <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-outline mr-2" @click="cancel">Cancelar</button>
        <button class="btn btn-primary" @click="save" :disabled="disabledSaveButton">Salvar</button>

      </div>

    </div>

    <ModalCityLogin v-if="showModalCityLogin" v-model="showModalCityLogin" :companyId="company.id"/>

  </div>
</template>

<script>
  import CitySelect from '@/components/shares/specialTag/CitySelect'
  import MethodMixins from './MethodMixins'
  import ModalCityLogin from '@/components/company/ModalCityLogin'
  import StatesSelect from '../shares/specialTag/StatesSelect'
  import Upload from '@/components/shares/specialTag/Upload'
  import { mask } from 'vue-the-mask'
  import { InfoIcon, UploadCloudIcon, FileIcon } from 'vue-feather-icons'

  export default {
    components: { CitySelect, FileIcon, InfoIcon, ModalCityLogin, StatesSelect, Upload, UploadCloudIcon },
    data() {
      return {
        showModalCityLogin: false
      }
    },
    directives: { mask },
    mixins: [MethodMixins],
    name: 'FormMatrix'
  }
</script>

<style scoped>
  .btn {
    min-width: 134px;
  }

  .upload {
    height: 95%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  svg.feather {
    color: var(--icon-color);
  }

  .password-certificate {
    border: solid 1px var(--border-color);
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 95%;
  }

  p {
    color: var(--primary-text-color);
  }

</style>
